import { Component, Input } from '@angular/core';
import { PropertyInfoForm } from '../../forms/property-info.form';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule, NgForOf, NgIf } from '@angular/common';
import { NgxMaskDirective } from 'ngx-mask';
import { ValidationErrorsComponent } from '../../../../../../../common/validation-errors/validation-errors.component';

@Component({
  selector: 'app-property-info-form',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    CommonModule,
    NgxMaskDirective,
    ValidationErrorsComponent
  ],
  templateUrl: './property-info-form.component.html'
})
export class PropertyInfoFormComponent {
  @Input()
  public form: PropertyInfoForm | undefined;
}
